import { Component } from '@angular/core';

@Component({
  selector: 'cam-calendar-bucket-container',
  standalone: true,
  templateUrl: './bucket-container.component.html',
  styleUrl: './bucket-container.component.scss',
})
export class CamBucketContainerComponent {}
